module.exports = __webpack_public_path__ + "img/redux-form.31533fa7.jpeg";